import moment from "moment";

// correctly html-encodes the "+" symbol in a date-time-with-timezone string
export function EncodeTimeZone(dateTime: string) {
    return dateTime.replace(`+`, `%2b`);
}

export function GetTodaysDate() {
    return moment().local().format("YYYY-MM-DD");
}

export function IsToday(dateTime: string) {
    const input = moment(dateTime).local();
    const now = moment().local();
    const isToday = input.isSame(now, "day");
    return isToday;
}
